/* tslint:disable */
/* eslint-disable */
/**
 * NN.CustomerPortal.ApiApp.General
 * GeneralAPIs
 *
 * The version of the OpenAPI document: 1.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const FufiPaymentStatus = {
    Unknown: 'Unknown',
    Pending: 'Pending',
    Paid: 'Paid',
    Payable: 'Payable'
} as const;
export type FufiPaymentStatus = typeof FufiPaymentStatus[keyof typeof FufiPaymentStatus];


export function instanceOfFufiPaymentStatus(value: any): boolean {
    for (const key in FufiPaymentStatus) {
        if (Object.prototype.hasOwnProperty.call(FufiPaymentStatus, key)) {
            if (FufiPaymentStatus[key as keyof typeof FufiPaymentStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function FufiPaymentStatusFromJSON(json: any): FufiPaymentStatus {
    return FufiPaymentStatusFromJSONTyped(json, false);
}

export function FufiPaymentStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): FufiPaymentStatus {
    return json as FufiPaymentStatus;
}

export function FufiPaymentStatusToJSON(value?: FufiPaymentStatus | null): any {
    return value as any;
}

export function FufiPaymentStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): FufiPaymentStatus {
    return value as FufiPaymentStatus;
}

